import type { ReactElement } from 'react';

import { REGEXP_PLACEHOLDER } from './constants';
import { createKeyDeduper } from './keyDeduper';
import type { KeyDeduper } from './keyDeduper';
import type { KeyWrapper } from './types';

export function interpolatePlaceholders(
  str: string,
  locale: string,
  keyWrapper: KeyWrapper | undefined,
  placeholders: Partial<Record<string, string | number>>,
  dedupeKey?: KeyDeduper
): string;
export function interpolatePlaceholders(
  str: string,
  locale: string,
  keyWrapper: KeyWrapper | undefined,
  placeholders: Partial<Record<string, string | number | ReactElement>>,
  dedupeKey?: KeyDeduper
): string | ReactElement[];
export function interpolatePlaceholders(
  str: string,
  locale: string,
  keyWrapper: KeyWrapper | undefined,
  placeholders: Partial<Record<string, string | number | ReactElement>>,
  dedupeKey: KeyDeduper = createKeyDeduper()
): string | (string | ReactElement)[] {
  const parts = str.split(REGEXP_PLACEHOLDER);
  let hasElement = false;
  const segments: (string | ReactElement)[] = [];

  for (let i = 0; i < parts.length; i++) {
    const isNonMatchingPart = i % 2 === 0;

    if (isNonMatchingPart) {
      if (parts[i]) {
        segments.push(parts[i]);
      }
    } else {
      const placeholderName = parts[i];
      const value = placeholders[placeholderName];

      if (value === undefined) {
        segments.push(`{${placeholderName}}`);
      } else if (typeof value === 'number') {
        segments.push(value.toLocaleString(locale));
      } else if (typeof value === 'string') {
        if (value) {
          segments.push(value);
        }
      } else {
        hasElement = true;
        segments.push(keyWrapper ? keyWrapper(dedupeKey(placeholderName), value) : value);
      }
    }
  }

  return hasElement ? segments : (segments as string[]).join('');
}
